<div id="tradingViewChart" class="chart"></div>